module.exports = __webpack_public_path__ + "media/paws/light-paws-1544b919.svg";